import pauseUnpauseMachineRequest from './pause-unpause-machine-request';

const asyncThunks = {
  pauseUnpauseMachineRequest,
};

export default asyncThunks;
